module.exports = __webpack_public_path__ + "img/card-3.6c73f612.svg";